import theme from '../../base';

const divider = {
  background: theme.colors.neutrals.gray900,
};

export default divider;
